import { LOCATION_CHANGE } from 'redux-first-history';

import { APP_INIT } from '../actions/config';
import { MODAL_TYPES } from '../constants/common';
import { NEWS_READING_POSTPONED } from '../../affiliates/actions/news';
import { SessionFeatures } from '../constants/ui';
import { collapseSidebarAction } from '../reducers/sidebar';
import {
  breakpointChangedAction,
  hideModalAction,
  isOnlineCheckedAction,
} from '../reducers/ui';

export enum Breakpoint {
  MobileSmall = 0,
  MobileMedium = 360,
  MobileLarge = 430,
  TabletSmall = 600,
  Tablet = 768,
  TabletLarge = 960,
  DesktopSmall = 1024,
  DesktopMedium = 1200,
  DesktopHuge = 1368,
}

const breakpoints = [
  Breakpoint.MobileSmall,
  Breakpoint.MobileMedium,
  Breakpoint.MobileLarge,
  Breakpoint.TabletSmall,
  Breakpoint.Tablet,
  Breakpoint.TabletLarge,
  Breakpoint.DesktopSmall,
  Breakpoint.DesktopMedium,
  Breakpoint.DesktopHuge,
];

let timeout;

const handleMediaChange =
  (breakpoint, dispatch) =>
  (e, force = false) => {
    if (!e.matches && !force) {
      return;
    }
    clearTimeout(timeout);

    timeout = setTimeout(
      () =>
        dispatch(
          breakpointChangedAction(
            e.matches
              ? breakpoint
              : breakpoints[breakpoints.indexOf(breakpoint) - 1],
          ),
        ),
      50,
    );
  };

const updateVHValue = () => {
  document.documentElement.style.setProperty(
    '--vh',
    `${window.innerHeight / 100}px`,
  );
};
/**
 * System notifications middleware function
 */
const middleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    const state = getState();
    const result = next(action);

    if (
      action.type === hideModalAction.type &&
      state.ui.currentModalName === MODAL_TYPES.NEWS_ALERT_MODAL
    ) {
      dispatch({ type: NEWS_READING_POSTPONED });
      sessionStorage.setItem(
        `${SessionFeatures.HideNewsAlert}_${action.payload.id}`,
        'true',
      );
    }

    if (action.type === APP_INIT) {
      window.addEventListener('resize', updateVHValue);
      updateVHValue();
      breakpoints.forEach((breakpoint, index) => {
        const nextBreakpoint = breakpoints[index + 1];
        const constraints = [
          `(min-width: ${breakpoint}px)`,
          nextBreakpoint ? `(max-width: ${nextBreakpoint - 1}px)` : null,
        ];
        const media = window.matchMedia(
          constraints.filter(Boolean).join(' and '),
        );
        const handler = handleMediaChange(breakpoint, dispatch);

        if (media.matches) {
          handler(media, true);
        }

        if (media.addEventListener) {
          media.addEventListener('change', handler);
        } else if (media.addListener) {
          media.addListener(handler);
        }
      });
    }

    if (action.type === LOCATION_CHANGE) {
      dispatch(isOnlineCheckedAction(navigator.onLine));
      dispatch(collapseSidebarAction());
    }

    return result;
  };

export default middleware;
